import React from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';

import {
  ExtendedBox,
  ExtendedFlex,
  Data,
  Body,
  Heading,
  Theme,
} from '../../../coreui';
import LoadableHighcharts from '../../../components/LoadableHighcharts';

import colorShade from '../utils';

// eslint-disable-next-line
class PropertyTypesChart extends React.Component {
  constructor(props) {
    super(props);
    this._chart = React.createRef();
    this.state = {
      data: this.buildData(),
    };
  }

  buildData() {
    const data = this.props.data;
    const color = [...colorShade];
    const strings = this.props.strings;
    const descriptions = strings.reduce(
      (descriptions, { name, description: desc }, weight) => ({
        ...descriptions,
        [name]: {
          desc,
          weight,
        },
      }), {},
    );

    return Object.keys(data).map(
      (item) => {
        const desc = (data[item].label in descriptions) ? descriptions[data[item].label] : { desc: '', weight: 0 };
        return {
          name: data[item].label,
          y: data[item].stat,
          description: desc.desc,
          weight: desc.weight,
        };
      },
    )
      .sort((a, b) => a.weight - b.weight)
      .map((item) => {
        const i = item;
        i.color = color.shift();
        return item;
      });
  }

  Tooltip() {
    const style = {
      color: Theme.colors.blue[0],
    };
    return (
      <div>
        <Body type="B5" whiteSpace="nowrap">
          {this.props.label}:
        </Body>
        <br />
        <Data type="D2" whiteSpace="nowrap">
          {'{'}type{'}'}:{' '}
          <span style={style}>
            {'{'}percent{'}'}%
          </span>{' '}
          of Total
        </Data>
      </div>
    );
  }

  Label() {
    return (
      <Heading
        type="H8"
        whiteSpace="nowrap"
      >
        {this.props.label}
      </Heading>
    );
  }

  render() {
    const data = this.state.data;
    const renderedTooltip = ReactDOMServer.renderToStaticMarkup(this.Tooltip());
    const renderTooltip = function () {
      return renderedTooltip.replace(/\{type\}/gi, this.point.name).replace(/\{percent\}/gi, this.percentage.toFixed(2));
    };
    const label = ReactDOMServer.renderToStaticMarkup(this.Label());

    const addTitle = function () {
      if (this.title) {
        this.title.destroy();
      }

      const r = this.renderer;
      const x = this.series[0].center[0] + this.plotLeft;
      const y = this.series[0].center[1] + this.plotTop + 5;
      this.title = r.text(label, 0, 0)
        .hide()
        .add();

      const bbox = this.title.getBBox();
      this.title.attr({
        x: x - (bbox.width / 2),
        y,
      }).show();
    };

    const options = {
      title: {
        text: label,
      },
      colors: colorShade,
      chart: {
        renderTo: 'chart-column',
        backgroundColor: null,
        type: 'pie',
        height: '100%',
        events: {
          load: addTitle,
          redraw: addTitle,
        },
      },
      credits: {
        enabled: false,
      },
      yAxis: {
        gridLineWidth: 0,
        title: {
          text: '',
        },
        labels: {
          // eslint-disable-next-line
          format: '${value}',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: renderTooltip,
      },
      series: [{
        data,
        size: '100%',
        innerSize: '90%',
        showInLegend: true,
        dataLabels: {
          enabled: false,
        },
        shadow: false,
        slicedOffset: 0,
        states: {
          hover: {
            halo: false,
          },
        },
      }],
    };

    return (
      <ExtendedBox>
        <ExtendedFlex
          flexDirection={['column', 'column', 'row', 'row', 'row']}
          justifyContent="center"
          alignItems="center"
        >
          <ExtendedBox
            w={['98%', '98%', '45%', '45%', '45%']}
            maxWidth={425}
            ml="auto"
            mr={['auto', 'auto', 0, 0, 0]}
            mt={[0, 0, 20, 20, 20]}
            height="100%"
          >
            <LoadableHighcharts
              options={options}
              ref={(el) => { this._chart = el; }}
            />
          </ExtendedBox>
          <ExtendedBox
            w={['90%', '90%', '45%', '40%', '40%']}
            mx={[25, 30, 50, 65, 75]}
            marginTop={20}
            height="100%"
          >
            <ExtendedFlex
              flexDirection="column"
              justifyContent="space-evenly"
              height="100%"
            >
              {
                data.map(
                  (string) => {
                    return (
                      <ExtendedFlex
                        flexDirection="row"
                        justifyContent="flex-start"
                        py={10}
                      >
                        <ExtendedBox
                          bg={string.color}
                          height="15px"
                          width="15px"
                          flex="0 0 auto"
                          alignSelf="flex-start"
                          mt={5}
                        />
                        <ExtendedBox
                          ml={15}
                          alignSelf="flex-start"
                        >
                          <Data
                            type="D1"
                          >
                            {string.name}
                          </Data>
                          <br />
                          <Data
                            type="D3"
                          >
                            {string.description}
                          </Data>
                        </ExtendedBox>
                      </ExtendedFlex>
                    );
                  },
                )
              }
            </ExtendedFlex>
          </ExtendedBox>
        </ExtendedFlex>
      </ExtendedBox>
    );
  }
}

PropertyTypesChart.propTypes = {
  data: PropTypes.object,
  strings: PropTypes.object,
  label: PropTypes.string,
};

export default PropertyTypesChart;
